import { ProjectSelector } from '../ProjectSelector'
import { ScenarioSelector } from '../ScenarioSelector'
import { ThemeToggle } from '../ThemeToggle'
import styles from './Sidebar.module.css'

export function Sidebar() {
  return (
    <div className={styles['sidebar']}>
      {/* Scrollable Content */}
      <div className={styles['content']}>
        <ProjectSelector />
        <ScenarioSelector />
        <ThemeToggle />
      </div>
    </div>
  )
}
